var define = undefined;
var $ = require('jquery');
var vue = require('vue');
var qs = require('querystring');
var moment = require('moment');
var BlogIndex = require('./blog/index');
var BlogArticle = require('./blog/article');
var ShareButton = require('./share');
var query = qs.parse(location.search.substr(1));

// styles
require('../scss/blog/style.scss');

vue.filter('fmtDate', (date, format = 'MMMM Do, YYYY') => {
    return moment(date).local().format(format);
});

vue.filter('trunc', function (text, length = 300) {
    return text.substr(0, length) + '...';
});

const getSlug = () => {
  const { href } = window.location;

  const match = href.match(/\/articles\/([\w-]+)[?\/#]*/);
  if (match && match[1]) {
    return match[1];
  }
  return query.slug;
}

function initBlog(baseUrl, encodedSSID, encodedCompanyId) {
    if (!baseUrl) {
      return;
    }
    var blogBlock = $('.ss-blog');
    var blogArticleBlock = $('.ss-blog-article');
    var blogArticleShareBtn = $('.vt-share');
    var blogBlockEl = blogBlock.get(0);
    var blogArticleBlockEl = blogArticleBlock.get(0);
    var blogArticleShareBtnEl = blogArticleShareBtn.get(0);
    var categoryIds = blogBlock.attr('ss-category-ids');
    var slug = getSlug();

    if (window.location.host === 'pages.services') {
        // Rewrite links that are in the format /[slug/][article|index].html where slug is optional
        var rewriteLink = new RegExp('^\/([a-zA-Z0-9-]+\/)?(index|article)\.html$');
        var companyPath = '/' + window.location.pathname.split('/', 2)[1];
        $('a').each(function() {
            var href = this.getAttribute('href');
            if (rewriteLink.test(href)) {
                this.href = companyPath + href;
            }
        });
        $('div[ss-form-redirect]').each(function() {
            var href = this.getAttribute('ss-form-redirect');
            if (rewriteLink.test(href)) {
                this.setAttribute('ss-form-redirect', companyPath + href);
                var frame = $(this).find('iframe');
                if (frame) {
                    var src = $(frame).attr('src');
                    src = src.replace(/&redirectUrl=.*&/, '&redirectUrl=' + encodeURIComponent(companyPath + href) + '&');
                    $(frame).attr('src', src);
                }
            }
        });
    }

    if (!encodedCompanyId) {
        encodedCompanyId = blogBlock.attr('ss-enc-companyid');
    }

    if (categoryIds) {
        categoryIds = categoryIds.split(',').map((c) => {
            return +c;
        });
    }

    if (blogBlockEl) {
        new BlogIndex({
            el: blogBlockEl,
            data: {
                encodedCompanyId: encodedCompanyId,
                categoryIds: categoryIds,
                baseUrl: baseUrl
            }
        });
    }

    if (blogArticleBlockEl) {
        new BlogArticle({
            el: blogArticleBlockEl,
            data: {
                encodedCompanyId: encodedCompanyId,
                slug: slug,
                baseUrl: baseUrl
            }
        });
    }

    if (blogArticleBlockEl && blogArticleShareBtnEl) {
        let shareBtn = new ShareButton({
            data: {
                btn: blogArticleShareBtnEl,
                companyId: encodedCompanyId,
                slug: slug,
                baseUrl: baseUrl
            }
        });

        shareBtn.$mount().$appendTo(document.body);

    }
}

window.initBlog = initBlog;
module.exports = initBlog;



// WEBPACK FOOTER //
// ./src/js/blog.js